import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#00546F" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/104Sushizion/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Sushi Zion Japanese Restaurant Facebook"
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/sushi_zion/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Sushi Zion Japanese Restaurant Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#00546F" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/104Sushizion/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Sushi Zion Japanese Restaurant Facebook"
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/sushi_zion/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Sushi Zion Japanese Restaurant Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
